import { createStyles } from '@mantine/core';
var useStyles = createStyles(function (theme, _ref) {
  var zIndex = _ref.zIndex;
  return {
    notifications: {
      width: "calc(100% - ".concat(theme.spacing.md, " * 2)"),
      boxSizing: "border-box",
      position: "fixed",
      zIndex: zIndex
    },
    notification: {
      "&:not(:first-of-type)": {
        marginTop: theme.spacing.sm
      }
    }
  };
});
export default useStyles;